const initialState = {
    data: [],
  };
  
const uliceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ULICE':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default uliceReducer;